import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ISDPDataTableRowFormMeta {
  logField: FormInputMeta;
  logFieldTitle: FormInputMeta;
  logSourceTable: FormInputMeta;
  logKeyField: FormInputMeta;
  logKeyFieldDesc: FormInputMeta;

  schema: any;
}

const sdpDataTableRowFormMeta = {} as ISDPDataTableRowFormMeta;

sdpDataTableRowFormMeta.logField = {
    name: "logField",
    type: "select",
    options: [],
    label: "Log Field",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

sdpDataTableRowFormMeta.logFieldTitle = {
    name: "logFieldTitle",
    type: "text",
    label: "Log Field Title",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

sdpDataTableRowFormMeta.logSourceTable = {
    name: "logSourceTable",
    type: "select",
    options: [],
    label: "Log Source Table",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

sdpDataTableRowFormMeta.logKeyField = {
    name: "logKeyField",
    type: "select",
    options: [],
    label: "Log Key Field",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

sdpDataTableRowFormMeta.logKeyFieldDesc = {
    name: "logKeyFieldDesc",
    type: "select",
    options: [],
    label: "Log Key Field Desc",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};


sdpDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(sdpDataTableRowFormMeta));

export default sdpDataTableRowFormMeta;